import React__default from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';
import { useOlapicContext } from './OlapicContext/OlapicContext.js';

const Olapic = ({ apiKey , instance , locale , olapic , src , tags  })=>{
    const sku = useOlapicContext();
    const consentResult = useCookieConsentContext();
    const COOKIE_CONSENT = 'social';
    React__default.useEffect(()=>{
        if (isCookieCategoryEnabled(COOKIE_CONSENT, consentResult)) {
            //Create a script tag with the Olapic API
            const newScript = document.createElement('script');
            newScript.id = 'olapic-script';
            newScript.src = src;
            newScript.defer = true;
            newScript.type = 'text/javascript';
            newScript.setAttribute('data-instance', instance);
            newScript.setAttribute('data-tags', sku || tags);
            newScript.setAttribute('data-olapic', olapic);
            newScript.setAttribute('data-lang', locale);
            newScript.setAttribute('data-use-opi', 'false');
            newScript.setAttribute('data-apikey', apiKey);
            //Insert the script tag into the parent div of olapic
            const olapicDiv = document.getElementById(olapic);
            if (olapicDiv && olapicDiv.parentNode) {
                olapicDiv.parentNode.appendChild(newScript);
            }
        }
        return ()=>{
            const olapicScript = document.getElementById('olapic-script');
            if (olapicScript) {
                olapicScript.remove();
            }
        };
    }, [
        apiKey,
        consentResult,
        instance,
        locale,
        olapic,
        sku,
        src,
        tags
    ]);
    // Not allowed to render this component without the cookie consent
    if (!isCookieCategoryEnabled(COOKIE_CONSENT, consentResult)) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        id: olapic
    }));
};
var Olapic$1 = Olapic;

export { Olapic$1 as default };
//# sourceMappingURL=Olapic.js.map
